import { config } from "../../config";

export const isWhiteListed = () => {
  const { origin } = window.location;
  return !!config.qrCodeDomains.find(
    (domain) => domain === origin || origin.startsWith(domain)
  );
};

export default {
  isWhiteListed,
};
